@if (entity) {
  <div class="card">
    <div class="card-header">
      <div class="row align-items-center justify-content-between">
        <div class="col-auto">Tarefas</div>
        <div class="col-auto pt-1">
          @if (isSprintCanWrite()) {
            <patron-button
              class="ml-1"
              (click)="openBulkUpdateModal()"
              [disabled]="!entity.tasks || !entity.tasks.length || saving"
              >Atualizar em massa</patron-button
            >
          }
        </div>
      </div>
    </div>
    @if (entity.tasks?.length) {
      <div>
        @for (task of entity.tasks | sort: ['created_at', 'sequence']; track task; let i = $index) {
          <div
            class="row py-0 mx-0 border cursor-pointer"
            [class.task-row-even]="!task.finished && i % 2 == 0 && !isDelayed(task)"
            [class.task-delayed]="isDelayed(task)"
            [class.task-finished]="task.finished && !isDelayed(task)">
            <div class="col-12 py-0">
              @if (currentTask?.id != task?.id) {
                <div class="row">
                  <div class="col-5 pl-5 pb-0" (click)="showUpdateForm(task)">
                    <div class="row pl-1">
                      <div class="col-12 pl-0 py-0">
                        <b>Palavras-chave:</b> {{ task.summary || '' }}
                      </div>
                      <div class="col-12 pl-0 py-0">
                        <b>Status:</b>
                        @if (task?.status?.description) {
                          <span class="ml-1">
                            <patron-badge [color]="getStatusClass(task?.status?.description)">{{
                              task?.status?.description
                            }}</patron-badge>
                          </span>
                        }
                      </div>
                      <div class="col-12 pl-0 py-0"><b>Sequência:</b> {{ task.sequence }}</div>
                    </div>
                  </div>
                  <div class="col-3 pb-0" (click)="showUpdateForm(task)">
                    <div class="row">
                      <div class="col-12 py-0">
                        <b>Desenvolvedor:</b> {{ task?.user?.name || 'Sem desenvolvedor' }}
                      </div>
                      <div class="col-12 py-0">
                        <div class="row">
                          <div class="col-auto pr-0">
                            <b>Depende de:</b>
                          </div>
                          @if (task?.task_dependencies) {
                            <div class="col-auto pl-0">
                              @for (
                                taskDependency of task?.task_dependencies;
                                track taskDependency
                              ) {
                                <span class="mx-1">
                                  <patron-badge color="warning">{{
                                    taskDependency?.depends_on_task?.sequence
                                  }}</patron-badge>
                                </span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <!--<div class="col-12">
                      <span class="font-weight-bold">Concluída:</span> {{(task?.finished) ? 'Sim': 'Não'}}
                    </div>-->
                      <div class="col-12 py-0">
                        <b>Dificuldade: </b>
                        <span
                          class="badge"
                          [class.alert-success]="task?.difficulty === 'F'"
                          [class.alert-primary]="task?.difficulty === 'M'"
                          [class.alert-danger]="task?.difficulty === 'D'"
                          >{{ task?.difficulty | difficulty }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-3 pb-0" (click)="showUpdateForm(task)">
                    <div class="row">
                      <div class="col-12 py-0">
                        <b>Esforço Técnico:</b> {{ task?.estimated_effort }}
                        {{ task?.estimated_effort > 1 ? 'pontos' : 'ponto' }}
                      </div>
                      <div class="col-12 py-0">
                        <b>Prev. Original:</b>
                        {{ (task?.original_expected_date | date: 'dd/MM/yyyy') || 'Sem previsão' }}
                      </div>
                      <div class="col-12 pl-1 py-0">
                        <div class="row pl-1">
                          <div class="col-auto py-0 pr-2">
                            <b>Previsão:</b>
                            {{ (task?.expected_date | date: 'dd/MM/yyyy') || 'Sem previsão' }}
                          </div>
                          <div class="col py-0 px-0">
                            <input
                              type="checkbox"
                              [checked]="task?.change_ticket_expected_date"
                              disabled
                              title="Alterar previsão do chamado" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-1 pr-0">
                    <div class="row">
                      <div class="col-5"></div>
                      <div class="col-auto">
                        @if (isSprintCanWrite()) {
                          <patron-button
                            iconName="pi pi-trash"
                            color="danger"
                            class="ml-1 pr-0"
                            (click)="deleteModalSwitch(task)"
                            [disabled]="saving"></patron-button>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="col-12 py-0 pl-4" (click)="showUpdateForm(task)">
                    <div class="row">
                      <div class="col-auto py-0">
                        <b>Sistemas:</b>
                      </div>
                      @for (system of task.systems; track system) {
                        <div class="col-auto py-0 px-1">
                          <patron-badge color="secondary">
                            {{ system.description }}
                          </patron-badge>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-12 py-0 pl-4" (click)="showUpdateForm(task)">
                    <b>Descrição:</b><br />
                    <markdown [data]="task.description || ''"></markdown>
                  </div>
                  @if (!currentTask) {
                    <div class="col-12 mt-1">
                      <div class="row">
                        <div class="row pl-4 mb-0">
                          <div class="col-auto">
                            @if (isSprintCanWrite()) {
                              <patron-button
                                [iconName]="
                                  saving
                                    ? 'pi pi-spin pi-spinner'
                                    : task.finished
                                      ? 'pi pi-times'
                                      : 'pi pi-check'
                                "
                                [color]="task.finished ? 'warning' : 'primary'"
                                (click)="finish(i, false)"
                                [disabled]="saving">
                                @if (task.finished) {
                                  <span> Marcar como não concluída </span>
                                }
                                @if (!task.finished) {
                                  <span> Concluir </span>
                                }
                              </patron-button>
                            }
                          </div>
                          @for (btn of getTaskLogButtons(task); track btn) {
                            <div class="col-auto">
                              @if (isSprintCanWrite()) {
                                <patron-button
                                  [iconName]="saving ? 'pi pi-spin pi-spinner' : 'pi pi-clock'"
                                  color="secondary"
                                  [disabled]="saving"
                                  (click)="
                                    ticketLogs.emit({
                                      task: task,
                                      system: btn,
                                    })
                                  ">
                                  {{
                                    btn?.id ? (btn?.description | truncate: [20]) : 'Apontamentos'
                                  }}
                                </patron-button>
                              }
                            </div>
                          }
                          @for (log of getTaskOpenedLogs(task); track log) {
                            <div class="col-auto tc-user-icon">
                              <patron-badge color="danger">
                                <patron-icon name="pi-clock"></patron-icon> {{ log.user?.name }}
                              </patron-badge>
                            </div>
                          }
                          @if (tasksProgress.loading) {
                            <div class="col-auto">
                              <patron-spinner></patron-spinner> Carregando progresso...
                            </div>
                          }
                          @if (
                            tasksProgress.loaded &&
                            tasksProgress.data &&
                            tasksProgress.data[task.id] &&
                            tasksProgress.data[task.id].percentage
                          ) {
                            <div class="col">
                              <patron-progress
                                [color]="getTaskProgressBarType(task)"
                                [value]="tasksProgress.data[task.id].percentage">
                                {{ getTaskProgressBarLabel(task) }}
                              </patron-progress>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (task?.id && currentTask?.id && currentTask?.id === task?.id) {
                <div>
                  <ng-container [ngTemplateOutlet]="formTaskContainer"> </ng-container>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (!entity.tasks?.length) {
      <div class="text-center p-4">
        <span>Nenhuma tarefa foi adicionada</span>
      </div>
    }
    <div class="card-footer">
      @if (!currentTask?.id) {
        <ng-container [ngTemplateOutlet]="formTaskContainer"> </ng-container>
      }
      <div class="row">
        <div class="col">
          <div class="my-2 mr-1">
            <div class="mr-3">
              <b>Pontos concluídos: </b>
              {{ effectiveEffort }}/{{ entity.estimated_effort }}
              <b class="ml-3">Pontos restantes: </b>
              {{ remainingEffort }}
            </div>
            <div>
              <b>Previsão final: </b>
              {{ (entity.expected_date | date: 'dd/MM/yyyy') || 'Sem previsão' }}
            </div>
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
          <div class="my-2 ml-1">
            @if (!currentTask && isSprintCanWrite()) {
              <patron-button
                iconName="pi pi-plus"
                (click)="initNewTask()"
                [disabled]="saving"
                [loading]="saving">
                Adicionar tarefa
              </patron-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<patron-modal
  title="Deletar tarefa"
  cancelButtonText="cancelar"
  confirmButtonText="confirmar"
  [visible]="visibleDeleteModal"
  (confirm)="deleteTask(currentTask)"
  (cancel)="deleteModalSwitch(currentTask!)">
  <p>Tem certeza que deseja excluir essa tarefa?</p>
  @if (currentTask && currentTask!.description) {
    <span>
      <p>{{ currentTask!.description }}</p>
    </span>
  }
</patron-modal>
<patron-modal
  title="Marcar como não concluída"
  cancelButtonText="cancelar"
  confirmButtonText="confirmar"
  [visible]="visibleUnfinishTaskModal"
  (confirm)="unfinishConfirm()"
  (cancel)="unfinishTaskModalSwitch()">
  <p>Você tem certeza de que deseja marcar essa tarefa como não concluída?</p>
</patron-modal>
<app-task-bulk-update
  [visible]="visibleUpdateModal"
  [tasks]="entity?.tasks || []"
  (confirm)="confirmBulkUpdate($event)"></app-task-bulk-update>
<ng-template #formTaskContainer>
  <patron-form
    [formGroup]="formGroup"
    [hidden]="!currentTask"
    novalidate
    class="form-horizontal {{ wasValidatedTask ? 'was-validated' : '' }} h-100">
    @if (currentTask) {
      <div>
        <div class="row">
          <div class="col-6 pb-0">
            <patron-form-field
              type="number"
              [formGroup]="formGroup"
              formControlName="sequence"
              label="Sequencia"
              placeholder="sequencia"
              customClass="mb-1">
            </patron-form-field>
          </div>
          <div class="col-6 pb-0">
            <patron-form-field
              [formGroup]="formGroup"
              formControlName="summary"
              label="Palavra-chave"
              placeholder="Palavra-chave"
              customClass="mb-1">
            </patron-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 py-0">
            <patron-textarea
              [formGroup]="formGroup"
              (ngModelChange)="descriptionChanged()"
              formControlName="description"
              label="Descrição *"
              [rows]="rowNumber"
              [includeBR]="false"
              customClass="mb-1"
              name="description"
              (focus)="onDescriptionFocus()"
              (blur)="onDescriptionBlur()">
            </patron-textarea>
            @if (wasValidatedTask && !currentTask.description) {
              <div>Por favor informe a descrição da tarefa</div>
            }
          </div>
          <div class="col-12 py-0">
            <patron-select
              [formGroup]="formGroup"
              formControlName="taskSystems"
              placeholder="Sistemas"
              bindLabel="description"
              orderBy="description"
              label="Sistemas"
              modelName="systems"
              [multiple]="true">
            </patron-select>
          </div>
          <div class="col-lg-6 py-0 pl-2">
            <patron-select
              [formGroup]="formGroup"
              formControlName="ticketStatus"
              orderBy="ref"
              placeholder="Status"
              bindLabel="description"
              label="Status *"
              modelName="ticket-statuses"
              customClass="mb-0">
            </patron-select>
          </div>
          <div class="col-lg-6 py-0 pr-2">
            <patron-select
              [formGroup]="formGroup"
              formControlName="developer"
              placeholder="Desenvolvedor"
              bindLabel="name"
              orderBy="ref"
              label="Desenvolvedor"
              modelName="users"
              customClass="mb-1">
            </patron-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 pl-2">
            <patron-form-field
              type="number"
              [formGroup]="formGroup"
              formControlName="taskEstimatedEffort"
              label="Esforço técnico"
              placeholder="Esforço técnico"
              customClass="mb-1">
            </patron-form-field>
          </div>
          <div class="col-lg-4 py-0">
            <patron-select
              [formGroup]="formGroup"
              [items]="difficulties"
              formControlName="difficulty"
              placeholder="Dificuldade"
              bindLabel="label"
              label="Dificuldade"
              customClass="mb-1">
            </patron-select>
          </div>
          <div class="col-lg-4 pr-2">
            <patron-form-field
              type="number"
              [formGroup]="formGroup"
              formControlName="priority"
              label="Prioridade sprint"
              placeholder="Prioridade sprint"
              customClass="mb-1">
            </patron-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 pl-2">
            <patron-form-field
              type="date"
              [formGroup]="formGroup"
              formControlName="originalExpectedDateString"
              [value]="originalExpectedDateString"
              label="Previsão Original"
              placeholder="Previsão Original"
              customClass="mb-1">
            </patron-form-field>
          </div>
          <div class="col-6 d-flex align-items-center py-0">
            <div class="col-lg-4">
              <patron-form-check
                [inputTemplate]="input"
                [labelTemplate]="label"
                class="mt-4 mb-1 pr-2 d-flex justify-content-end">
                <ng-template #input>
                  <input
                    type="checkbox"
                    id="changeTicketExpectedDate"
                    formControlName="changeTicketExpectedDate"
                    title="Alterar previsão do chamado" />
                </ng-template>
                <ng-template #label>
                  <label for="changeTicketExpectedDate">Previsão</label>
                </ng-template>
              </patron-form-check>
            </div>
            <div class="col-lg-8">
              <patron-form-field
                type="date"
                formControlName="expectedDateString"
                [formGroup]="formGroup"
                placeholder="Previsão"
                customClass="mt-4 mb-1">
              </patron-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col py-0">
            <patron-select
              [multiple]="true"
              placeholder="Tarefas das quais essa tarefa depende"
              [items]="dependsOnOptions"
              name="taskDependencies"
              bindLabel="label"
              label="Depende de"
              formControlName="dependsOnTasks"
              customClass="mb-3">
            </patron-select>
          </div>
          <div class="col-lg-4 col-xl-3 d-flex align-items-end justify-content-end">
            @if (currentTask) {
              <patron-button
                color="secondary"
                size="lg"
                class="ml-1"
                (click)="cancelEdit()"
                [disabled]="saving"
                customClass="mr-3 mb-3"
                >Cancelar</patron-button
              >
            }
            @if (isSprintCanWrite()) {
              <patron-button
                size="lg"
                [iconName]="saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                (click)="saveTask()"
                [disabled]="saving"
                customClass="mb-3">
                Salvar
              </patron-button>
            }
          </div>
        </div>
      </div>
    }
  </patron-form>
</ng-template>
